/*
Small screen menu, the parts a details element does not give you.

The menu opens and closes without this file. It is a details element, so the
markup alone gives the toggle, the keyboard and the announced state. This adds
three things a details element does not do by itself:

  Escape closes it, which every visitor expects of an overlay.
  The page behind it stops scrolling while it is open.
  A link that points at the current page closes it, because the browser will not
  navigate and the panel would otherwise stay over the section you jumped to.

This runs whatever the visitor's motion preference is. main.js is gated on
allowMotion, so anything called from inside that gate does not exist for a
visitor with reduced motion switched on. A navigation cannot be optional.
*/

export function nav() {
  const menu = document.querySelector('.nav__menu');

  if (!menu) return;

  const close = () => {
    menu.open = false;
  };

  menu.addEventListener('toggle', () => {
    document.body.classList.toggle('nav-is-open', menu.open);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) close();
  });

  /* A same page link leaves the panel sitting over the target. Close it. */
  menu.querySelectorAll('a[href]').forEach((link) => {
    link.addEventListener('click', () => {
      if (link.hash && link.pathname === window.location.pathname) close();
    });
  });
}
